import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/discharged`;

export const getDischargedPatients = async (cipId = null, locationId = null) => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: {
        cipId,
        locationId
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching discharged patients:", error);
    throw error;
  }
};
